// extracted by mini-css-extract-plugin
module.exports = {"extras":"Extras_extras__pve1F","wrapper":"Extras_wrapper__1LZgr","title":"Extras_title__2OgPh"};